import { gql } from '@apollo/client';
import { WarrantyIssueInfo } from '../fragments';

export default gql`
  mutation destroyWarrantyIssue($input: WarrantyIssueDestroyInput!) {
    destroyWarrantyIssue(input: $input) {
      clientMutationId
      warrantyIssue {
        ...WarrantyIssueInfo
      }
    }
  }
  ${WarrantyIssueInfo}
`;
